import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import { serialize } from "../../../helpers/utils/Utils";

export const taxRoundingConfigApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchTaxRoundingConfig: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/tax-rounding-configs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['taxRoundingConfigs'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getTaxRoundingConfigById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-tax-rounding-configs-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['taxRoundingConfigById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createTaxRoundingConfig: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create-tax-round-config`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['taxRoundingConfigs'],
            async onQueryStarted(_, { queryFulfilled }) {
                    const { data } = await queryFulfilled;
                    // assuming response: { message: "Rounding config created successfully", ... }
                    await handleQueryErrorAndSuccess(data, "Created", data?.message);
            }
        }),

        updateTaxRoundingConfig: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update-tax-round-config-by-id/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['taxRoundingConfigs', 'taxRoundingConfigById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Metro Area")
            },
        }),

        deleteTaxRoundingConfigById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-tax-round-config-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['taxRoundingConfigs'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Rounding Config");
            },
        }),

    }),
});


export const {
    useSearchTaxRoundingConfigQuery,
    useGetTaxRoundingConfigByIdQuery,
    useCreateTaxRoundingConfigMutation,
    useUpdateTaxRoundingConfigMutation,
    useDeleteTaxRoundingConfigByIdMutation
} = taxRoundingConfigApi;